module.exports = __webpack_public_path__ + "static/digital-titan-mag-b1b6f68c2fe00028c911a1e92b6cf5d1.jpg";